import { AfterViewInit, ChangeDetectorRef, Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { ToastrService } from 'ngx-toastr';
import { AppService } from 'src/app/app.service';
import { PatientService } from 'src/app/patients/patient.service';
import { environment } from 'src/environments/environment';

@Component({
  selector: 'app-side-menu-contributor',
  templateUrl: './side-menu-contributor.component.html',
  styleUrls: ['./side-menu-contributor.component.css']
})
export class SideMenuContributorComponent implements OnInit, AfterViewInit {

  patient: any;

  constructor(
    private router: Router,
    private toastr: ToastrService,
    public app: AppService,
    private service: PatientService,
    private cd: ChangeDetectorRef,
  ) { }

  searchTerm: string = '';

  ngOnInit(): void {
    this.getPatientById();
  }
  
  ngAfterViewInit(): void {
    this.cd.detectChanges();
  }



  getPatientById = () => {
    this.service.getPatientById(this.app.getUserData().id).subscribe(
      res => {
        if (res.errorCode == 0) {
          this.patient = res.data
          this.cd.detectChanges();
        }
      }
    )
  }


  
  applyFilter() {
    if (this.searchTerm.trim() !== '' && this.searchTerm.length > 2) {
      this.app.HcpsAuth = this?.app?.allHCPs.filter((hcp) =>
        hcp.fullName.toLowerCase().includes(this.searchTerm.toLowerCase())
      );
    } else {
      this.app.HcpsAuth = this.app.allHCPs.slice(0, 8); 
      if(this?.app?.getSelectedHcpForCont()){
        this.app.HcpsAuth.unshift(this?.app?.getSelectedObjHcpForCont())
      }
    }
  }

}
